import { Route, Routes } from "react-router-dom";

import AdminDrawer from "@components/Admin/AdminDrawer";
import PageContainer from "@components/PageContainer";
import { SlidesStepperNavButtons, SlideStepper, SlideStepperBreadcrumbs } from "@components/Slides/SlideStepper";

import Companies from "@pages/Companies/components/Companies";
import CompaniesContacts from "@pages/Companies/components/CompaniesContacts";
import useDirectorySlideStepper from "@pages/Companies/useDirectorySlideStepper";

function Index() {
  const { breadcrumbs, slideIndex, slides } = useDirectorySlideStepper();

  return (
    <PageContainer>
      {slides[slideIndex] && (
        <SlideStepper>
          <SlideStepperBreadcrumbs
            breadcrumbs={breadcrumbs}
            handleClickIndex={(index) => breadcrumbs[index]?.onClick()}
            index={slideIndex}
            workflow="smart-search"
          />
          <SlidesStepperNavButtons
            backButtonTooltip={slides[slideIndex].backButtonTooltip}
            handleBack={slides[slideIndex].handleBack}
            handleNext={slides[slideIndex].handleNext}
            isBackButtonDisabled={slides[slideIndex].isBackButtonDisabled}
            isBackButtonPending={false}
            isNextButtonDisabled={slides[slideIndex].isNextButtonDisabled}
            isNextButtonPending={slides[slideIndex].isNextButtonPending || false}
            nextButtonStyle={slides[slideIndex].nextButtonStyle}
            nextButtonText={slides[slideIndex].nextButtonText}
            nextButtonTooltip={slides[slideIndex].nextButtonTooltip}
            showNextButton={slides[slideIndex].showNextButton}
          />
        </SlideStepper>
      )}
      <Routes>
        <Route element={<Companies />} path="/companies" />
        <Route element={<CompaniesContacts />} path="/contacts" />
      </Routes>
      <AdminDrawer />
    </PageContainer>
  );
}

export default Index;
